import PropTypes from 'prop-types'
import React from 'react'

export default function CustomAttributes({ t, customAttributes }) {
  if (!customAttributes || !customAttributes.length) return null

  return (
    <div className="product-addition">
      <h2 className="product-addition-headline">{t('components.productComponent.customAttributes')}</h2>
      {customAttributes.map((attribute) => (
        <dl
          className="product-addition-list"
          key={attribute.key}
          itemProp="additionalProperty"
          itemScope
          itemType="http://schema.org/PropertyValue"
        >
          <dt itemProp="name">{attribute.displayKey}</dt>
          <dd itemProp="value">{attribute.displayValue}</dd>
        </dl>
      ))}
    </div>
  )
}

CustomAttributes.propTypes = {
  t: PropTypes.func.isRequired,
  customAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      displayKey: PropTypes.string.isRequired,
      displayValue: PropTypes.string.isRequired,
    }),
  ),
}
